<template>
  <div class="content">
    <div class="top-wrap">
      <button class="refresh-btn" @click="init(1)">刷新<i class="el-icon-refresh el-icon--right" /></button>
    </div>
    <el-table class="table" :header-cell-style="{background:'#f5f7fa'}" :data="infoList" :max-height="tableMaxHeight" border>
      <el-table-column prop="index_name" label="名称" align='left' min-width="200" />
      <el-table-column align='left' label="导出链接" min-width="200">
        <template slot-scope="{ row }">
          <span
            v-if="row.file_url"
            style="color:#5B7BFE;cursor:pointer;"
            @click="onClickDownloadBtn(row.file_url)"
          >{{ row.file_url }}</span>
          <span v-else style="color:#FF9B3B;">-</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态" width="100">
        <template slot-scope="{ row }">
          <span v-if="row.status == 1">待处理</span>
          <span v-else-if="row.status == 2" style="color:#FF9B3B;">导出中</span>
          <span v-else-if="row.status == 3" style="color:green;">导出完成</span>
          <span v-else-if="row.status == -1" style="color:red;">导出失败</span>
        </template>
      </el-table-column>
      <el-table-column prop="operater_name" label="操作人" align='center' width="100" />
      <el-table-column prop="created_at" label="创建时间" align='center' width='200' />
      <el-table-column align='center' label="操作" width="140px">
        <template slot-scope="{ row }">
          <button class="download-btn" @click="row.file_url?onClickDownloadBtn(row.file_url):''" :style="!row.file_url?'background:#ccc;cursor: no-drop;':''">下载</button>
        </template>
      </el-table-column>
    </el-table>
    <div class="paginationBox" style="height: 30px;">
      <el-pagination small background :current-page="page" @current-change="handleCurrentChange" :page-size="page_size" layout="total, prev, pager, next, jumper" :total="total" />
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      page: 1,
      page_size: 20,
      total: 0,
      infoList: [],
    }
  },
  computed: {
    // 计算表格最大高度，确保分页控件可见
    tableMaxHeight() {
      return window.innerHeight - 200 > 400 ? window.innerHeight - 200 : 400;
    }
  },
  created () {
    this.init(1)
  },
  methods: {
    async onClickDownloadBtn(file_url) {
      try {
        await this.$confirm(`确定下载当前报表吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        this.exportEvent(file_url)
      } catch (error) {
        console.log('error => ', error)
      }
    },
    exportEvent (file_url) {
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = file_url;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    handleCurrentChange (val) {
      this.init(val)
    },
    init (page) {
      this.page = page ? page : this.page;
      this.$loading(this.$loadingConfig);
      this.$axios.get(this.URL.BASEURL + this.URL.export_index, {
        params: {
          page: this.page,
          page_size: this.page_size,
          // type: 1
        }
      }).then((res) => {
        var res = res.data;
        this.$loading(this.$loadingConfig).close()
        if (res && res.errno == 0) {
          this.infoList = res.rst.data
          this.total = res.rst.pageInfo.total;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.$loading(this.$loadingConfig).close()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.content {
  padding: 20px 20px 15px;
  background: #fff;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  min-height: calc(100vh - 100px);
  .table {
    flex: 1;
    min-height: 0;
  }
  .paginationBox {
    flex-shrink: 0;
    margin-top: 15px;
    padding-bottom: 0;
  }
}
button {
  min-width: 60px;
  height: 26px;
  border-radius: 4px;
  color: #ffffff;
  font-size: 12px;
  border: none;
  padding: 0 6px;
  &.download-btn {
    background: #5b7bfe;
  }
  &.refresh-btn {
    background: #67c23a;
  }
}
.top-wrap {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/exportList.vue